import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';

function Counter({ to, suffix = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    const start = performance.now();
    const duration = 1400;
    let raf;
    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setValue(Math.round(to * eased));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to]);

  return (
    <span ref={ref}>
      {value}
      {suffix}
    </span>
  );
}

const stats = [
  { value: 3, suffix: '+', label: 'Years Building Web' },
  { value: 5, suffix: '+', label: 'Projects Shipped' },
  { value: 5, suffix: '+', label: 'Happy Clients' },
  { value: 100, suffix: '%', label: 'Hand-Crafted Code' }
];

function Stats() {
  return (
    <section
      aria-label="Highlights"
      className="relative overflow-hidden border-y border-ink/10 bg-snow/70"
    >
      <div className="section-wrap grid grid-cols-2 gap-y-8 py-12 md:grid-cols-4 md:gap-0 md:divide-x md:divide-ink/10 md:py-16">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="px-2 text-center md:px-6"
          >
            <div className="font-display text-5xl font-bold tracking-[-0.03em] text-ink md:text-6xl">
              <Counter to={s.value} suffix={s.suffix} />
            </div>
            <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.24em] text-ink/55">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
